import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function Message$Companion$$childSerializers$_anonymous__yfg1gj() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()));
}
function Message$Companion$$childSerializers$_anonymous__yfg1gj_0() {
  return new (ArrayListSerializer())(StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Message$Companion$$childSerializers$_anonymous__yfg1gj);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.q6x_1 = [null, null, null, tmp_1, null, null, lazy(tmp_2, Message$Companion$$childSerializers$_anonymous__yfg1gj_0)];
      }
      d2b() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.zegreatrob.coupling.logging.Message', this, 7);
        tmp0_serialDesc.g1z('level', false);
        tmp0_serialDesc.g1z('name', false);
        tmp0_serialDesc.g1z('message', false);
        tmp0_serialDesc.g1z('properties', false);
        tmp0_serialDesc.g1z('timestamp', false);
        tmp0_serialDesc.g1z('marker', true);
        tmp0_serialDesc.g1z('stackTrace', true);
        this.r6x_1 = tmp0_serialDesc;
      }
      s6x(encoder, value) {
        var tmp0_desc = this.r6x_1;
        var tmp1_output = encoder.s1r(tmp0_desc);
        var tmp2_cached = Companion_getInstance().q6x_1;
        tmp1_output.i1t(tmp0_desc, 0, value.t6x_1);
        tmp1_output.i1t(tmp0_desc, 1, value.u6x_1);
        tmp1_output.m1t(tmp0_desc, 2, StringSerializer_getInstance(), value.v6x_1);
        tmp1_output.m1t(tmp0_desc, 3, tmp2_cached[3].n3(), value.w6x_1);
        tmp1_output.i1t(tmp0_desc, 4, value.x6x_1);
        if (tmp1_output.q1t(tmp0_desc, 5) ? true : !(value.y6x_1 == null)) {
          tmp1_output.m1t(tmp0_desc, 5, StringSerializer_getInstance(), value.y6x_1);
        }
        if (tmp1_output.q1t(tmp0_desc, 6) ? true : !(value.z6x_1 == null)) {
          tmp1_output.m1t(tmp0_desc, 6, tmp2_cached[6].n3(), value.z6x_1);
        }
        tmp1_output.t1r(tmp0_desc);
      }
      c1n(encoder, value) {
        return this.s6x(encoder, value instanceof Message() ? value : THROW_CCE());
      }
      d1n(decoder) {
        var tmp0_desc = this.r6x_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.s1r(tmp0_desc);
        var tmp12_cached = Companion_getInstance().q6x_1;
        if (tmp11_input.i1s()) {
          tmp4_local0 = tmp11_input.c1s(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.c1s(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.g1s(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.g1s(tmp0_desc, 3, tmp12_cached[3].n3(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.c1s(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.g1s(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.g1s(tmp0_desc, 6, tmp12_cached[6].n3(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.j1s(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.c1s(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.c1s(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.g1s(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.g1s(tmp0_desc, 3, tmp12_cached[3].n3(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.c1s(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.g1s(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.g1s(tmp0_desc, 6, tmp12_cached[6].n3(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x1o(tmp2_index);
            }
          }
        tmp11_input.t1r(tmp0_desc);
        return Message().a6y(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      b1n() {
        return this.r6x_1;
      }
      w1z() {
        var tmp0_cached = Companion_getInstance().q6x_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3].n3()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[6].n3())];
      }
    }
    protoOf($).x1z = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var MessageClass;
function Message() {
  if (MessageClass === VOID) {
    class $ {
      constructor(level, name, message, properties, timestamp, marker, stackTrace) {
        Companion_getInstance();
        marker = marker === VOID ? null : marker;
        stackTrace = stackTrace === VOID ? null : stackTrace;
        this.t6x_1 = level;
        this.u6x_1 = name;
        this.v6x_1 = message;
        this.w6x_1 = properties;
        this.x6x_1 = timestamp;
        this.y6x_1 = marker;
        this.z6x_1 = stackTrace;
      }
      toString() {
        return 'Message(level=' + this.t6x_1 + ', name=' + this.u6x_1 + ', message=' + this.v6x_1 + ', properties=' + toString(this.w6x_1) + ', timestamp=' + this.x6x_1 + ', marker=' + this.y6x_1 + ', stackTrace=' + toString(this.z6x_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.t6x_1);
        result = imul(result, 31) + getStringHashCode(this.u6x_1) | 0;
        result = imul(result, 31) + (this.v6x_1 == null ? 0 : getStringHashCode(this.v6x_1)) | 0;
        result = imul(result, 31) + (this.w6x_1 == null ? 0 : hashCode(this.w6x_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.x6x_1) | 0;
        result = imul(result, 31) + (this.y6x_1 == null ? 0 : getStringHashCode(this.y6x_1)) | 0;
        result = imul(result, 31) + (this.z6x_1 == null ? 0 : hashCode(this.z6x_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Message()))
          return false;
        if (!(this.t6x_1 === other.t6x_1))
          return false;
        if (!(this.u6x_1 === other.u6x_1))
          return false;
        if (!(this.v6x_1 == other.v6x_1))
          return false;
        if (!equals(this.w6x_1, other.w6x_1))
          return false;
        if (!(this.x6x_1 === other.x6x_1))
          return false;
        if (!(this.y6x_1 == other.y6x_1))
          return false;
        if (!equals(this.z6x_1, other.z6x_1))
          return false;
        return true;
      }
      static a6y(seen0, level, name, message, properties, timestamp, marker, stackTrace, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance().r6x_1);
        }
        var $this = createThis(this);
        $this.t6x_1 = level;
        $this.u6x_1 = name;
        $this.v6x_1 = message;
        $this.w6x_1 = properties;
        $this.x6x_1 = timestamp;
        if (0 === (seen0 & 32))
          $this.y6x_1 = null;
        else
          $this.y6x_1 = marker;
        if (0 === (seen0 & 64))
          $this.z6x_1 = null;
        else
          $this.z6x_1 = stackTrace;
        return $this;
      }
    }
    initMetadataForClass($, 'Message', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    MessageClass = $;
  }
  return MessageClass;
}
//region block: exports
export {
  Message as Messageyu2c6n5qdmq,
  Companion_getInstance as Companion_getInstance20bpwyuqfvwiw,
};
//endregion

//# sourceMappingURL=Message.mjs.map
